import React, { Component } from "react";
import { Link } from "react-router-dom";

export default class preadmission extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="container">
          <br />
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to={"/"}>Home</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Pre Admission
              </li>
            </ol>
          </nav>
        </div>
        <div className="container">
          <span className="welcome_text">Pre Admission</span>
          <hr />
        </div>
        <div>
          You are required to give the GRE exam and for English proificiency you have following three options: TOEFL, IELTS and Duolingo
          Minimum TOEFL score requirement: overall score of 80 with at least 20 on speaking and writing
          <br />
          Minimum IELTS score requirement: overall band-width of 6.5, with no single band (score) below 6.0
          <br />
          Minimum Duolingo score requirement: overall score of 105
          <br />
          The above may change, to check the latest requirement use this link:
          <a
            href="https://grad.uga.edu/index.php/prospective-students/international-application-information/international-supplement/english-language-proficiency-requirement/"
            target={"_blank"}
            rel={"noreferrer"}
            className="redLink"
          >
            GRE/TOEFL/IELTS/Duolingo requirement
          </a>
          <br />
          However for TA ship the requirements are : IELTS Speaking({">"}=8), TOEFL speaking({">"}=26), Duolingo overall ({">"}=135)
        </div>
        <div>
          Letter of recommendation Most departments require at least three letters of recommendation in support of each application for
          admission. List the names of recommenders in the fields on page three of the application along with their e-mail addresses. They
          will receive a link to access a secure page where they can submit your recommendation quickly and easily via the Web.
        </div>
        <div>
          Application Fee details:{" "}
          <a
            href="http://grad.uga.edu/index.php/prospective-students/domestic-application-information/requirements/application-fee/"
            target={"_blank"}
            rel={"noreferrer"}
            className="redLink"
          >
            Application Fee
          </a>
        </div>
      </React.Fragment>
    );
  }
}
